import { Form, useFormikContext } from 'formik';
import Button from '@mui/material/Button';
import { makeStyles } from 'tss-react/mui';
import * as Yup from 'yup';

export const newLinkInviteSchema = Yup.object().shape({
});

const useStyles = makeStyles()((theme) => ({
  generateButton: {
    margin: theme.spacing(2, 0)
  }
}));

type Props = {
  disabled?: boolean;
};

const NewLinkInviteForm = ({ disabled: formDisabled }: Props) => {
  const { isSubmitting } = useFormikContext();
  const { classes } = useStyles();
  const disabled = isSubmitting || formDisabled;
  return (
    <Form>
      <Button
        type="submit"
        sx={{ mt: 2 }}
        disabled={disabled}
        variant="contained"
        color="primary"
        className={classes.generateButton}
      >
        Generate Invite Link
      </Button>
    </Form>
  );
};

export default NewLinkInviteForm;
